import { Link } from 'gatsby';
import React from 'react';
import { useDeviceDetect } from '../../../../hooks';

export default function Slogan() {
  const isMobile = useDeviceDetect(425);

  return (
    <section className="slogan">
      <div className="slogan__container">
        <h1 className="slogan__title">
          Smart HR and Talent management solutions
        </h1>
        <p className="slogan__subtitle">
          {isMobile
            ? 'The Ultimate Tool to Optimize Your Business Experience'
            : 'HIRE. RETAIN. DEVELOP. GROW'}
        </p>
        <p className="slogan__information">
          Grow your business by unlocking your employees&apos; full potential.
          bravoSUITE offers a full cycle of smart HR and talent management
          solutions customized for your business.
        </p>
        <Link to="/pricing" className="slogan__btn">
          See Plans
        </Link>
      </div>
    </section>
  );
}
